import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import SpeechToTextRTC from "./SpeechToText/SpeechToTextRTC";
import { TextField } from "@mui/material";

const ChatPopup = ({ open, onClose }) => {
  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "Need Assistance? Just Ask! I'm Learner's Assistant.",
      sender: "assistant",
    },
  ]);
  const [inputValue, setInputValue] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputValue.trim()) return;

    const userMessage = {
      id: Date.now(),
      text: inputValue,
      sender: "user",
    };

    setMessages((prevMessages) => [...prevMessages, userMessage]);
    setInputValue("");
    setIsTyping(true);

    try {
      const response = await axios.post(
        "/ai/chat",
        { prompt: userMessage.text },
        { config: { handlerEnabled: true } }
      );

      if (response.data && response.data.success) {
        const assistantMessage = {
          id: Date.now() + 1,
          text: response.data.data,
          sender: "assistant",
        };
        setMessages((prevMessages) => [...prevMessages, assistantMessage]);
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      console.error("Chat API error:", error);
      const errorMessage = {
        id: Date.now() + 1,
        text: "Sorry, I'm having trouble connecting. Please try again later.",
        sender: "assistant",
      };
      setMessages((prevMessages) => [...prevMessages, errorMessage]);
    } finally {
      setIsTyping(false);
    }
  };

  if (!open) return null;
  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.25)",
          zIndex: 1399,
        }}
        onClick={onClose}
      />
      {/* Centered Popup */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1400,
          width: 800,
          height: 600,
          maxWidth: "95vw",
          maxHeight: "85vh",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "#5335CA",
            color: "#fff",
            padding: "16px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span style={{ fontWeight: 600 }}>Chat with Learner's Assistant</span>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "#fff",
              fontSize: 20,
              cursor: "pointer",
            }}
            aria-label="Close chat"
          >
            ×
          </button>
        </div>
        {/* Messages area */}
        <div
          style={{
            flex: 1,
            padding: 16,
            background: "#f7f7fa",
            overflowY: "auto",
          }}
        >
          {messages.map((message) => (
            <div
              key={message.id}
              style={{
                display: "flex",
                justifyContent:
                  message.sender === "user" ? "flex-end" : "flex-start",
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  background: message.sender === "user" ? "#5335CA" : "#e6e6fa",
                  color: message.sender === "user" ? "#fff" : "#333",
                  borderRadius: 8,
                  padding: "10px 14px",
                  maxWidth: "80%",
                  wordBreak: "break-word",
                  whiteSpace: "pre-line", // <-- Add this line
                }}
              >
                {message.text}
              </div>
            </div>
          ))}
          {isTyping && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  background: "#e6e6fa",
                  color: "#333",
                  borderRadius: 8,
                  padding: "10px 14px",
                  maxWidth: "80%",
                }}
              >
                <i>Typing...</i>
              </div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>
        {/* Input area */}
        <form
          style={{
            display: "flex",
            alignItems: "flex-end", // 👈 Align items to the bottom
            borderTop: "1px solid #eee",
            background: "#fff",
            position: "relative",
          }}
          onSubmit={handleSubmit}
        >
          <TextField
            multiline
            minRows={1}
            maxRows={5}
            placeholder="Type your message..."
            value={inputValue}
            onChange={handleInputChange}
            variant="outlined"
            fullWidth
            InputProps={{
              sx: {
                fontSize: 15,
                padding: 0,
                "&.MuiInputBase-root": {
                  backgroundColor: "#fff",
                  padding: "14px",
                  borderRadius: "4px",
                },
                "& .MuiInputBase-inputMultiline": {
                  paddingRight: {
                    xs: "13%",
                    sm: "7%",
                    md: "5%",
                  },
                },
              },
              notched: false, // Optional: removes the label notch
            }}
            sx={{
              marginRight: "40px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
            }}
          />

          <div style={{ position: "relative" }}>
            <SpeechToTextRTC
              setDescription={(text) => {
                console.log("chat input text", text);
                setInputValue(inputValue + " " + text);
              }}
            />
          </div>
          <button
            type="submit"
            style={{
              background: "#5335CA",
              color: "#fff",
              border: "none",
              padding: "10px 18px", // Adjust padding to keep it visually aligned
              fontSize: 10,
              cursor: inputValue ? "pointer" : "not-allowed",
              opacity: inputValue ? 1 : 0.7,
              alignSelf: "flex-end", // 👈 Ensures it aligns independently
              marginBottom: 6, // 👈 Optional tweak for visual alignment
            }}
            disabled={!inputValue || isTyping}
          >
            ➤
          </button>
        </form>
      </div>
    </>
  );
};

export default ChatPopup;
